/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { TCarrinhoItem } from "../types";
import { Box, IconButton } from "@mui/material";
import { Formater, LocalStorage, TypeRecords } from "src/framework/commons";
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade";
import { Delete } from "@mui/icons-material";
import Grid from '@mui/material/Grid';

import './styles.scss';
import { CarrinhoStoreClass } from "../store";
import { resolveUploadUrl } from "src/store/global.store";

interface IItem {
    item: TCarrinhoItem;
    index: number;
    onRemove: (index: number) => void;
    onChange: (index: number, quantidade: number) => void;
}


const Item:FC<IItem> = ({ item, index, onRemove, onChange }) => {
    const uploadUrl = resolveUploadUrl(LocalStorage.get("solar.uploads", true) || null) || ""
    const [quantidadeMax, setQuantidadeMax] = useState<number>(1);
    const [quantidadeMin, setQuantidadeMin] = useState<number>(1);

    const imgUrl = useCallback(() => {
        return `//${uploadUrl}${item?.produto?.imagem}` || "";
    }, [item.produto?.imagem, uploadUrl]);

    const valorPorQuantidade = () => { 
       return CarrinhoStoreClass.valorTotal(item) * item.quantidade;
    }

    const gruposEstrutura = useMemo(() => {
        return LocalStorage.get("solar.estruturas", true) || [];
    }, []);

    const renderTipoEstrutura = useCallback(() => {
        const _estrutura = gruposEstrutura?.data?.find((estrutura: any) => estrutura.id === item?.produto?.tipo_estrutura_id);
        return _estrutura?.nome || "";
    }, [item?.produto?.tipo_estrutura_id, gruposEstrutura]);

    useEffect(()=>{
        if (item?.produto){        
            setQuantidadeMax(item?.produto?.quantidade_maxima || quantidadeMax)
            setQuantidadeMin(item?.produto?.quantidade_minima|| quantidadeMin)
        }
        if(item?.produto?.quantidade_minima){
            if(item?.quantidade < item?.produto?.quantidade_minima){
                item.quantidade = item.produto.quantidade_minima
            }
        }
    },[])
    return (
        <Box className="Item">
            <Grid className="box-container">
                <Grid className="box-imagem" size="grow">
                    <img className="imagem" src={imgUrl()} alt="" />
                </Grid>
                <Grid className="box-detalhes" size="grow">
                    <Box className="produto-nome"><strong style={{wordWrap: "break-word"}}>{item?.produto?.nome || ""}</strong></Box>
                    <Box className="estrutura">{renderTipoEstrutura()}</Box>
                    <Box className="valor-total">{Formater.toString(valorPorQuantidade(), TypeRecords.CURRENCY)} <span className="quantidade_valor">({item.quantidade}x {Formater.toString(CarrinhoStoreClass.valorTotal(item), TypeRecords.CURRENCY)})</span></Box>
                </Grid>
                <Grid className="box-quantidade" size="grow">
                    <InputQuantidade 
                        value={item?.quantidade}
                        disableMenos={item?.quantidade <= quantidadeMin}
                        maxValue={quantidadeMax}
                        minValue={quantidadeMin}
                        onChange={(e: any) => {
                            onChange(index, e)
                        }}

                    />
                </Grid>
                <Grid className="box-remover" size="grow">
                    <IconButton onClick={() => onRemove(index)} size="large"><Delete color="error"/></IconButton>
                </Grid>
            </Grid>
        </Box>
    );
}

export { Item }